import React from "react";
import "./Styles.css";

export default function ForecastDay(props) {
  function maxTemp() {
    let temperature = Math.round(props.data.temperature.maximum);
    return `${temperature}`;
  }
  function minTemp() {
    let temperature = Math.round(props.data.temperature.minimum);
    return `${temperature}`;
  }

  function day() {
    let days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    let date = new Date(props.data.time * 1000);
    let day = date.getDay();
    return days[day];
  }

  return (
    <div className="ForecastDay">
      <div className="DailyForecastWeekday">
        {day()}
        <img
          src={props.data.condition.icon_url}
          alt={props.data.condition.description}
          class="mx-auto"
        />
      </div>
      <div className="DailyForecastTemp">
        <span className="max-temp">{maxTemp()}°</span>
        <span className="min-temp">{minTemp()}°</span>
      </div>
    </div>
  );
}
